import dayjs from "dayjs"
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore"
import { Inventory } from "../Type"

export const getEmptyInventory = (): Inventory => {
  return {
    id: "",
    name: "",
    quantity: 0,
    purchasePrice: 0,
    unitPrice: 0,
    inventoryImageName: "",
    inventoryImageUri: "",
    insertDate: dayjs().valueOf(),
    lastEditDate: dayjs().valueOf(),
  }
}

export const getInventoryFromDocSnapshot = (
  doc: QueryDocumentSnapshot<DocumentData, DocumentData>
): Inventory => {
  return {
    id: doc.id,
    name: doc.data().name,
    quantity: doc.data().quantity,
    purchasePrice: doc.data().purchasePrice,
    unitPrice: doc.data().unitPrice,
    inventoryImageUri: doc.data().inventoryImageUri,
    inventoryImageName: doc.data().inventoryImageName,
    insertDate: doc.data().insertDate,
    lastEditDate: doc.data().lastEditDate,
  }
}
